"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateRange = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var Legend_1 = require("../../atoms/Legend");
var Button_1 = require("../../atoms/Button");
var DatePicker_1 = require("../DatePicker");
var styles_1 = __importDefault(require("./styles"));
exports.DateRange = react_1.default.memo(function (_a) {
    var idPrefix = _a.idPrefix, legend = _a.legend, onChange = _a.onChange, startDate = _a.startDate, endDate = _a.endDate, _b = _a.inline, inline = _b === void 0 ? true : _b, _c = _a.enclosed, enclosed = _c === void 0 ? false : _c, _d = _a.clearable, clearable = _d === void 0 ? true : _d, rest = __rest(_a, ["idPrefix", "legend", "onChange", "startDate", "endDate", "inline", "enclosed", "clearable"]);
    var _e = react_1.default.useState({
        startDate: startDate,
        endDate: endDate,
    }), state = _e[0], setState = _e[1];
    var classes = (0, styles_1.default)();
    // const { debounce } = useDebounce<(state: TDateRangeState) => void>(onChange);
    var handleStartDateChange = function (date) {
        var update = __assign(__assign({}, state), { startDate: date });
        setState(update);
        onChange(update);
    };
    var handleEndDateChange = function (date) {
        var update = __assign(__assign({}, state), { endDate: date });
        setState(update);
        onChange(update);
    };
    var handleClear = function () {
        var update = __assign(__assign({}, state), { startDate: undefined, endDate: undefined });
        setState(update);
        onChange(update);
    };
    // NOTE: MUI date pickers used here do not have an event to pass back
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(legend || clearable) && ((0, jsx_runtime_1.jsxs)(core_1.Box, __assign({ display: "flex", alignItems: "center", justifyContent: "space-between" }, { children: [legend ? (0, jsx_runtime_1.jsx)(Legend_1.Legend, { children: legend }) : (0, jsx_runtime_1.jsx)("div", { children: "\u00A0" }), (0, jsx_runtime_1.jsx)(Button_1.Button, __assign({ id: "".concat(idPrefix, "ClearDatesButton"), variant: "text", size: "small", onClick: handleClear }, { children: "Clear Dates" }))] }))), (0, jsx_runtime_1.jsxs)(core_1.Box, __assign({ display: "flex", "data-testid": "date-range" }, { children: [(0, jsx_runtime_1.jsxs)(core_1.Box, __assign({ flexGrow: 1, mr: 2 }, { children: [enclosed && (0, jsx_runtime_1.jsx)("p", __assign({ className: classes.enclosedLabel }, { children: "FROM" })), (0, jsx_runtime_1.jsx)(DatePicker_1.DatePicker, __assign({ id: "".concat(idPrefix, "DatePickerStartDate"), label: "FROM", value: state.startDate, onChange: function (date) { return handleStartDateChange(date); }, variant: inline ? "inline" : undefined, enclosed: enclosed, fullWidth: true }, rest))] })), (0, jsx_runtime_1.jsxs)(core_1.Box, __assign({ flexGrow: 1, ml: 2 }, { children: [enclosed && (0, jsx_runtime_1.jsx)("p", __assign({ className: classes.enclosedLabel }, { children: "TO" })), (0, jsx_runtime_1.jsx)(DatePicker_1.DatePicker, __assign({ id: "".concat(idPrefix, "DatePickerEndDate"), label: "TO", value: state.endDate, onChange: function (date) { return handleEndDateChange(date); }, variant: inline ? "inline" : undefined, enclosed: enclosed, fullWidth: true }, rest))] }))] }))] }));
});
